import Vue from 'vue';
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertModule from 'vux/src/plugins/alert/module'


export default {
success(msg = '已完成') {
Vue.use(ToastPlugin, {
time: 3000,
text: msg,
});
},

error(msg = '系统繁忙') {
AlertModule.show({
title: '发生错误',
content: msg,
});
},

alert(msg) {
AlertModule.show({
title: '提示',
content: msg,
});
},
};



// WEBPACK FOOTER //
// ./src/libs/alertify.js